import React from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';

import type { Artist } from 'types';

import { FONT } from '../constants';
import ArtistIdentity from './artist-identity';

interface ArtistMultiPickerProps {
  options: Artist[];
  value: Artist[];
  onChange: (artists: Artist[]) => void;
  placeholder?: string;
}

// Multi-select artist autocomplete; options render with the shared ArtistIdentity
// (avatar + name + meta line). Shared by the Collab Club admin modals.
const ArtistMultiPicker: React.FC<ArtistMultiPickerProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select artists…',
}) => (
  <Autocomplete
    multiple
    options={options}
    value={value}
    onChange={(_, picked) => onChange(picked)}
    getOptionLabel={(a) => a.name}
    isOptionEqualToValue={(o, v) => o.id === v.id}
    renderInput={(params) => <TextField {...params} size="small" placeholder={placeholder} />}
    renderOption={(props, a) => (
      <Box component="li" {...props}>
        <ArtistIdentity
          artist={a}
          avatarSize={28}
          nameWeight={500}
          nameSize={FONT.base}
          align="center"
        />
      </Box>
    )}
  />
);

export default ArtistMultiPicker;
